import type { UserWithSettingsResponse } from '@lib/responses/user';
import { ResourceEnum } from '@prisma/client';
import { useAuth } from '@ui/state/auth';

export type CurrentUser = UserWithSettingsResponse;

export function useCurrentUser(): {
  currentUser: CurrentUser;
  isSuperAdmin: boolean;
} {
  const { user: currentUser } = useAuth();

  if (!currentUser) {
    throw new Error('Current user expected but missing!');
  }

  const userSuperadminPermission = currentUser?.permissions?.find(
    (permission) => permission.resource === ResourceEnum.SUPERADMIN,
  );

  const isSuperAdmin = !!(
    userSuperadminPermission && userSuperadminPermission.read
  );

  return {
    currentUser,
    isSuperAdmin,
  };
}
